// extracted by mini-css-extract-plugin
export default {"form":"Dq2II9c0b759KhojvaEp","campuses":"jwKLc66IacwxhU7Uw6Z1","bounce":"uU_3b0STXJ7a9q8vCqBq"};